$(document).ready(function(){

	// -- Default options --
	jQuery.extend( jQuery.fn.pickadate.defaults, {
		formatSubmit: 'yyyy-mm-dd',
	  selectMonths: true,
	  selectYears: true
	});

	// -- Init pickadate --
	$('.datepicker').pickadate();

});